import "rsuite/dist/rsuite.css";
import React, { useState, useEffect, useCallback } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Form, Container, Row, Col, Table } from 'react-bootstrap';
import { renderPagination, renderAdvancedPagination, Remove_Bill_Modal, Edit_Bill_Modal } from '../utilities';
import { DateRangePicker } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash/debounce';
import '../Functions/manage_orders.css';
import { formatNumberWithCommas } from "../utilities";
import { useCommLogSummary, CommLogButton, CommLogStatus, CommunicationLogDrawer } from "../CommunicationLog/CommunicationLog";

function BillList() {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [bills, setBills] = useState([]);
    const [job_number, set_job_number] = useState('');
    const [bill_no, set_bill_no] = useState('');
    const [searchClick, setSearchClick] = useState(false); 
    const [style, set_style] = useState('');
    const [filters, setFilters] = useState({
        teamname: '',
        partyname: '',
        buyername: '',
        itemname: '',
        specification: '',
    });
    const [dateRange, setDateRange] = useState([]);
    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [billToDelete, setBillToDelete] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [billToEditId, setBillToEditId] = useState(null);
    const [commLogSummary, refreshCommLogSummary] = useCommLogSummary('BILL', bills.map(b => b.billId));
    const [commLogTarget, setCommLogTarget] = useState(null);
    const openCommLog = (bill) => {
        const first = bill.challans[0] || {};
        setCommLogTarget({ type: 'BILL', id: bill.billId, title: `Bill ${bill.billNo}`, subtitle: [first.partyName, first.buyerName].filter(Boolean).join(' · ') });
    };

    const [team_options, set_team_options] = useState([]);
    const [party_options, set_party_options] = useState([]);
    const [buyer_options, set_buyer_options] = useState([]);
    const [item_options, set_item_options] = useState([]);
    const [spec_options, set_spec_options] = useState(['Ply 1','Ply 2','Ply 3','Ply 5','Ply 7','PP']);

    useEffect(() => {
        fetch_dropdown_options();
    }, []);

    const fetch_dropdown_options = async () => {
        try {
            const response1 = await axios.get(`${window.backendUrl}/get_all_teams`);
            const response2 = await axios.get(`${window.backendUrl}/get_all_parties`);
            const response3 = await axios.get(`${window.backendUrl}/get_all_buyers`);
            const response4 = await axios.get(`${window.backendUrl}/get_all_items`);

            const options1 = response1.data.data.map((team) => team['Name']);
            const options2 = response2.data.data.map((party) => party['PartyName']);
            const options3 = response3.data.data.map((buyer) => buyer['Name']);
            const options4 = response4.data.data.map((item) => item['Name']);
            
            set_team_options(options1);
            set_party_options(options2);
            set_buyer_options(options3);
            set_item_options(options4);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFormData) => ({ ...prevFormData, [name]: value }));
        setCurrentPage(1);
    };

    const handleSearch = () => {
        setSearchClick(true);
        setCurrentPage(1);
    };

    const handleDateRangeChange = (value) => {
        if (value && value.length === 2) {
            setDateRange(value);
        } else {
            setDateRange([]);
        }
    };

    // Handler to open modal
    const handleSmallTrashClick = (bill) => {
        setBillToDelete(bill);
        setShowRemoveModal(true);
    };

    // Handler to open the edit modal
    const handleEditClick = (bill) => {
        setBillToEditId(bill.billId);
        setShowEditModal(true);
    };

    // Handler to execute delete
    const handleRemoveBill = (billId) => {
        axios.post(`${window.backendUrl}/remove_bill`, { bill_id: billId })
            .then(response => {
                setShowRemoveModal(false);
                // Refresh data
                fetchDataWithFilters(currentPage, filters, dateRange, job_number, style, bill_no);
            })
            .catch(error => {
                console.error('Error removing data!', error);
                alert("Failed to remove bill.");
            });
    };

    const fetchDataWithFilters = (page, filters, dateRange, job_number, style, bill_no) => { 
        const { teamname, partyname, buyername, itemname, specification} = filters; 
        const start_date = dateRange[0] ? dateRange[0] : ''
        const end_date = dateRange[1] ? dateRange[1] : ''

        axios.get(`${window.backendUrl}/get_all_bills`, {
            params: { teamname, partyname, buyername, itemname, specification, page, job_number, style, bill_no, start_date, end_date}
        })
        .then((response) => {
            setBills(response.data.data);
            setCurrentPage(response.data.currentPage);
            setTotalPages(response.data.totalPages);
            setSearchClick(false);
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const debouncedFetchData = useCallback(
        debounce((page, filters, dateRange, job_number, style, bill_no) => {
            fetchDataWithFilters(page, filters, dateRange, job_number, style, bill_no);
        }, 300), 
        []
    );

    useEffect(() => {
        debouncedFetchData(currentPage, filters, dateRange, job_number, style, bill_no);
        return () => {
            debouncedFetchData.cancel();
        };
    }, [filters, currentPage, searchClick, dateRange, job_number, style, bill_no, debouncedFetchData]);

    return (
    <>
        <NavigationBar />
        <Container fluid>
            <Row style={{ marginTop: '20px',marginBottom:'10px' }}>
                <Col>
                    <h4>Bill List</h4>
                </Col>
                <Col>
                    <DateRangePicker placeholder="Select Bill Date Range" onChange={handleDateRangeChange}/>
                </Col>
                <Col>
                    {renderPagination({ totalPages, currentPage, setCurrentPage })}
                    {renderAdvancedPagination({ totalPages, currentPage, setCurrentPage })}
                </Col>
            </Row>
            
            <Row style={{ marginTop: '20px',marginBottom:'10px' }}>
                <Form className='d-flex flex-wrap justify-content-around' onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
                    <Form.Select style={{width:'150px'}} name="partyname" value={filters.partyname} onChange={handleInputChange}>
                        <option value="">All Parties</option>
                        {party_options.map((party, index) => (
                            <option key={index} value={party}>{party}</option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="buyername" value={filters.buyername} onChange={handleInputChange}>
                        <option value="">All Buyers</option>
                        {buyer_options.map((buyer, index) => (
                            <option key={index} value={buyer}>{buyer}</option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="itemname" value={filters.itemname} onChange={handleInputChange}>
                        <option value="">All Items</option>
                        {item_options.map((item, index) => (
                            <option key={index} value={item}>{item}</option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="specification" value={filters.specification} onChange={handleInputChange}>
                        <option value="">All specification</option>
                        {spec_options.map((team, index) => (
                            <option key={index} value={team}>{team}</option>
                        ))}
                    </Form.Select>
                    
                    <Form.Control style={{width:'150px'}} type="text" name="style" value={style} onChange={(e) => { set_style(e.target.value); setCurrentPage(1); }} placeholder='Style/ LPD PO No.' />

                    <Form.Control style={{width:'150px'}} type="text" name="bill_no" value={bill_no} onChange={(e) => { set_bill_no(e.target.value); setCurrentPage(1); }} placeholder='Bill No.' />

                    <div className="search_container" style={{width:'150px'}} >
                        <Form.Control type="text" name="job_number" value={job_number} onChange={(e) => { set_job_number(e.target.value); setCurrentPage(1); }} placeholder='Job No.' />
                        <div onClick={handleSearch}><i className="fa fa-search"></i></div>
                    </div>
                </Form>
            </Row>

            <Row>
                <Col>
                    <Table bordered striped condensed="true" style={{ fontSize: '13px', overflowY: 'auto'  }}>
                        <thead className="cf" style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                            <tr>
                                <th rowSpan="2">SL / Date</th>
                                <th rowSpan="2">Bill No</th>
                                <th rowSpan="2">Company</th> 
                                <th rowSpan="2">Challan#</th>
                                <th>Job#</th>
                                <th rowSpan="2">Items</th>
                                <th rowSpan="2">Specif.</th>
                                <th>Measurement</th>
                                <th rowSpan="2">Ord.<br/>Qty</th>
                                <th rowSpan="2">Prod.<br/>Done</th>
                                <th colSpan="2">Delivery Info</th>
                                <th colSpan="2">Delivery Balance</th>
                                <th rowSpan="2">Packet</th>
                            </tr>
                            <tr>
                                <th>Style#</th>
                                <th>LxWxH</th>
                                <th>Qty</th>
                                <th>Value</th>
                                <th>Qty</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bills.map((bill, billIndex) => {
                                // Calculate total rowspan: (All lines in all challans) + 1 (for the Total row)
                                const totalBillRowSpan = bill.challans.reduce((acc, challan) => 
                                    acc + challan.items.reduce((acc2, item) => 
                                        acc2 + item.specifications.reduce((acc3, spec) => acc3 + spec.gsms.length, 0), 0), 0);
                                
                                const finalBillRowSpan = totalBillRowSpan + 1 + (bill.hasVat ? 2 : 0);
                                // We take the party/buyer from the first challan as representative for the whole bill
                                const firstChallan = bill.challans[0];

                                const billRows = bill.challans.map((challan, challanIndex) => {
                                    const challanRows = challan.items.map((item, itemIndex) => (
                                        item.specifications.map((spec, specIndex) => (
                                            spec.gsms.map((gsm, gsmIndex) => {
                                                const rowSpanLength = challan.items.reduce((acc, i) => acc + i.specifications.reduce((acc2, s) => acc2 + s.gsms.length, 0), 0);

                                                return (
                                                    <tr key={`${billIndex}-${challanIndex}-${itemIndex}-${specIndex}-${gsmIndex}`}>
                                                        
                                                        {/* Bill Columns: SL, Bill No, Company - Render ONE TIME per Bill */}
                                                        {challanIndex === 0 && itemIndex === 0 && specIndex === 0 && gsmIndex === 0 && (
                                                            <>
                                                                <td rowSpan={finalBillRowSpan} style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                                    {bill.serial_no}
                                                                    {/* Print Icon */}
                                                                        <div className="d-flex justify-content-center mt-2 gap-2">
                                                                            {/* Print Icon */}
                                                                            <i
                                                                                className="print-button fa fa-print"
                                                                                style={{ cursor: 'pointer', fontSize: '16px', marginRight: '8px' }}
                                                                                onClick={() => window.open(`/bill-pdf-viewer/${bill.billId}`, '_blank')}
                                                                                title="Print Bill"
                                                                            ></i>

                                                                            {bill.hasSavedDocument === 1 && (
                                                                                <i
                                                                                    className="fa fa-file-text-o"
                                                                                    style={{ cursor: 'pointer', fontSize: '16px', marginRight: '8px' }}
                                                                                    onClick={() => window.open(`/bill-saved-pdf-viewer/${bill.billId}`, '_blank')}
                                                                                    title="View Saved PDF"
                                                                                ></i>
                                                                            )}

                                                                            {/* Edit Icon */}
                                                                            <i
                                                                                className="fa fa-pencil"
                                                                                style={{ cursor: 'pointer', fontSize: '16px', marginRight: '8px' }}
                                                                                onClick={() => handleEditClick(bill)}
                                                                                title="Edit Bill"
                                                                            ></i>

                                                                            {/* Delete Icon */}
                                                                            <i 
                                                                                className="fa fa-trash-o" 
                                                                                style={{ cursor: 'pointer', fontSize: '16px', color: 'red' }} 
                                                                                onClick={() => handleSmallTrashClick(bill)}
                                                                                title="Delete Bill"
                                                                            ></i>
                                                                        </div>
                                                                        <div className="mt-2">
                                                                            <CommLogButton info={commLogSummary[bill.billId]} onClick={() => openCommLog(bill)} />
                                                                        </div>
                                                                        <div className="d-flex justify-content-center" style={{ textAlign: 'left' }}>
                                                                            <CommLogStatus info={commLogSummary[bill.billId]} onClick={() => openCommLog(bill)} />
                                                                        </div>                                                                   
                                                                    <hr style={{ border: '1px solid black' }}/>
                                                                    {new Date(bill.billDate * 1000).toLocaleString('en-GB', { timeZone: 'Asia/Dhaka', day: '2-digit', month: '2-digit', year: 'numeric'}).replace(/\//g, '.')}
                                                                </td>
                                                                <td rowSpan={finalBillRowSpan} style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                                                    {bill.billNo}
                                                                    {bill.cashOfBillId && <><br/><span style={{ fontSize: '11px', color: '#8a5a00' }}>(Cash bill)</span></>}
                                                                </td>
                                                                <td rowSpan={finalBillRowSpan} style={{verticalAlign: 'middle'}}>
                                                                    {firstChallan.partyName}
                                                                    <hr style={{ border: '1px solid black' }}/>
                                                                    {firstChallan.buyerName}
                                                                </td>
                                                            </>
                                                        )}

                                                        {/* Challan Columns: Challan No, Job No */}
                                                        {itemIndex === 0 && specIndex === 0 && gsmIndex === 0 && (
                                                            <>
                                                                <td rowSpan={rowSpanLength}>{challan.challanNo}</td>
                                                                <td style={{width: '200px', wordWrap: 'break-word', wordBreak: 'break-word'}} rowSpan={rowSpanLength}>
                                                                    {challan.jobNo}
                                                                    <hr style={{ border: '1px solid black' }}/>
                                                                    {challan.style}
                                                                </td>
                                                            </>
                                                        )}
                                                        
                                                        {/* Item Column */}
                                                        {gsmIndex === 0 && specIndex === 0 && (
                                                            <td style={{ verticalAlign: 'middle' }} rowSpan={item.specifications.reduce((acc, s) => acc + s.gsms.length, 0)}>{item.itemName}</td>
                                                        )}
                                                        
                                                        {/* Specification Column */}
                                                        {gsmIndex === 0 && (
                                                            <td style={{ verticalAlign: 'middle' }} rowSpan={spec.gsms.length}>{spec.specification}</td>
                                                        )}
                                                        
                                                        {/* Data Columns */}
                                                        <td>{gsm.measurement}</td>
                                                        <td>{gsm.orderQuantity}</td>
                                                        <td>{gsm.finishedQty}</td>
                                                        <td>{gsm.deliveryQty}</td>
                                                        <td>৳{(gsm.deliveryValue).toFixed(2)}</td>
                                                        <td>{gsm.deliveryBalance}</td>
                                                        <td>৳{(gsm.balanceValue).toFixed(2)}</td>
                                                        <td>{gsm.packet_qty_sum}</td>
                                                    </tr>
                                                );
                                            })
                                        ))
                                    ));
                                    return challanRows;
                                });

                                // Total Row for the Bill
                                const totalRow = (
                                    <tr key={`total-${billIndex}`} className="green_row" style={{fontWeight: 'bold'}}>
                                        {/* Spacer to skip Challan(col 4) and Job(col 5). 
                                            SL(1), Bill(2), Company(3) are rowspanned from above, so we start drawing at col 4. 
                                            We want to start text at Items(col 6), so we skip 2 cols. */}

                                        {/* Total Label spanning Items(6), Specif(7), Measurement(8) */}
                                        <td colSpan="5" style={{textAlign: 'right', verticalAlign: 'middle'}}>Total:</td>
                                        
                                        <td>{bill.totals.orderQuantity}</td>
                                        <td>{bill.totals.finishedQty}</td>
                                        <td>{bill.totals.deliveryQty}</td>
                                        <td>৳{formatNumberWithCommas(bill.totals.deliveryValue.toFixed(2))}</td>
                                        <td>{bill.totals.deliveryBalance}</td>   
                                        <td>৳{formatNumberWithCommas(bill.totals.balanceValue.toFixed(2))}</td>
                                        <td>{Number(bill.totals.packet_qty_sum)}</td>
                                    </tr>
                                );

                                const vatRows = bill.hasVat ? [
                                    <tr key={`vat-${billIndex}`} className="green_row" style={{fontWeight: 'bold'}}>
                                        <td colSpan="8" style={{textAlign: 'right', verticalAlign: 'middle'}}>VAT 15%{bill.vatInclusive ? ' (included in prices)' : ''}{bill.vatChallanNo ?` (Vat Challan no-${bill.vatChallanNo})` : ''}:</td>
                                        <td>৳{formatNumberWithCommas(bill.vatAmount.toFixed(2))}</td>
                                        <td colSpan="3"></td>
                                    </tr>,
                                    <tr key={`grand-${billIndex}`} className="green_row" style={{fontWeight: 'bold'}}>
                                        <td colSpan="8" style={{textAlign: 'right', verticalAlign: 'middle'}}>Grand Total:</td>
                                        <td>৳{formatNumberWithCommas(bill.grandTotal.toFixed(2))}</td>
                                        <td colSpan="3"></td>
                                    </tr>
                                ] : [];

                                return [...billRows, totalRow, ...vatRows];
                            })}
                        </tbody>
                    </Table>
                    <Edit_Bill_Modal
                        show={showEditModal}
                        setShow={setShowEditModal}
                        bill_id={billToEditId}
                        onSaved={() => fetchDataWithFilters(currentPage, filters, dateRange, job_number, style, bill_no)}
                    />
                    <Remove_Bill_Modal 
                        show={showRemoveModal}  
                        setShow={setShowRemoveModal} 
                        handleRemove={handleRemoveBill} 
                        bill={billToDelete}
                    />
                    <CommunicationLogDrawer target={commLogTarget} onHide={() => setCommLogTarget(null)} onSaved={refreshCommLogSummary} />
                </Col>
            </Row>
        </Container>
    </>
    )
}

export default BillList